<template>
  <div ref="editorRef" v-loading="loading"></div>
</template>

<script>
  import WangEditor from 'wangeditor'
  import { getBase64, compressImage, base64ToFile } from '@/util/util'
  import { isEmpty } from 'lodash-es'
  import { fileUpload } from '@/api'

  export default {
    name: 'RichTextEditor',
    props: {
      value: {
        type: String,
        required: true
      },
      config: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        loading: false,
        editor: null
      }
    },
    mounted() {
      this.initEditor()
    },
    methods: {
      initEditor() {
        const editorConfig = {
          // 默认配置项
          placeholder: '请输入内容',
          menus: [
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            'table',
            'code',
            'undo',
            'redo'
          ],
          zIndex: 1,
          height: 200,
          uploadImgMaxLength: 5,
          showLinkImg: false,
          colors: [
            '#333',
            '#666',
            '#999',
            '#22C655',
            '#FF881B',
            '#FA5151',
            '#FFFFFF',
            '#000000',
            '#096FFF',
            '#10AEFF'
          ],
          ...this.config
        }

        const editor = new WangEditor(this.$refs.editorRef)

        // 初始化编辑器配置
        editor.config = { ...editor.config, ...editorConfig }
        // 图片上传方法
        const _this = this
        editor.config.customUploadImg = async function (resultFiles, insertImgFn) {
          // resultFiles 是 input 中选中的文件列表
          // insertImgFn 是获取图片 url 后，插入到编辑器的方法
          if (!isEmpty(resultFiles)) {
            const fileLen = resultFiles.length
            if (fileLen > 0) {
              _this.loading = true
              for (let i = 0; i < fileLen; i++) {
                let compressFile = null
                if (resultFiles[i].type === 'image/gif') {
                  // gif文件不压缩
                  compressFile = resultFiles[i]
                } else {
                  // 压缩图片
                  const base64 = await getBase64(resultFiles[i])
                  const compressBase64 = await compressImage(base64, 0.9)
                  compressFile = base64ToFile(compressBase64, resultFiles[i].name)
                }
                const fileData = new FormData()
                fileData.append('file', compressFile)
                fileData.append('code', 'rtf')
                const { code, data } = await fileUpload(fileData)
                if (code === 0 && !isEmpty(data)) {
                  const { url } = data
                  insertImgFn(url)
                }
                // 请求已统一拦截，业务场景下，就不再做提示，先关闭，看运行效果
                /* else if (msg) {
                  this.$message.error(msg)
                } else {
                  _this.$message.error(`第${i + 1}张上传失败，请重试！`)
                } */
              }
              _this.loading = false
            }
          }
        }
        // 监听内容变化事件
        editor.config.onchange = (newHtml) => {
          this.$emit('input', newHtml)
        }

        // 创建编辑器
        editor.create()
        // 设置初始内容
        editor.txt.html(this.value || '')

        // 将编辑器实例存储在组件的实例上，以便后续访问
        this.editor = editor
      }
    }
  }
</script>
